module.exports = __webpack_public_path__ + "static/media/coursera.628096eb.svg";